// @flow

import unifizeUser from "./index";
import Email from "src/components/user/Email";

export default unifizeUser(Email);
